import { toJS } from 'mobx';
import React, { useEffect, useMemo, useState } from 'react';
import { AdvancedTable } from '../../components/AdvancedTable/AdvancedTable';
import EventLabel from '../../components/EventLabel/EventLabel';
import {  basedAxios } from '../../store/Store';

export const ExhibitorInviteList = ({ orders, settings, breakouts, mainEvent, eventLabels, environment, updateEventLabels, ordersLoaded }) => {
  const { personTypes = [], editLinkUrl, showAltName = false, showExportBtn = false } = settings;
  const [personList, setPersonList] = useState(null);

  useEffect(() => {
    if (toJS(orders)[0]?.badgeNo) {
      updatePersonList(orders[0].badgeNo);
    }
  }, [ordersLoaded]);

  const columnDefs = useMemo(() => {
    const cols = [
      {
        accessorKey: 'firstName',
        header: <EventLabel groupName="CMS.Voucher" name="PersonListFirstName" />,
        filterFn: 'fuzzy',
        cell: info => info.getValue(),
      },
      {
        accessorKey: 'lastName',
        header: <EventLabel groupName="CMS.Voucher" name="PersonListLastName" />,
        filterFn: 'fuzzy',
      },
      {
        accessorKey: 'email',
        header: <EventLabel groupName="CMS.Voucher" name="PersonListEmail" />,
        filterFn: 'fuzzy',
      },
      {
        accessorKey: 'companyName',
        header: <EventLabel groupName="CMS.Voucher" name="PersonListCompany" />,
        filterFn: 'fuzzy',
      },
    ];
    if (personList?.[0] && breakouts) {
      for (const key in personList[0]) {
        if (Object.hasOwnProperty.call(personList[0], key) && key.startsWith('ev')) {
          const evId = parseInt(key.replace('ev', ''));
          const ev = mainEvent.eventId == evId ? mainEvent : breakouts.find(b => b.eventId == evId);
          const lang = ev.eventDisplayLanguage?.find(edl => edl.languageCode == environment.lang && edl.alternative == showAltName);
          cols.push({
            accessorKey: key,
            header: lang?.name || ev?.name,
            enableColumnFilter: false,
            hozAlign: 'center',
            cell: cell => {
              if (cell.getValue()) return <i className="ri-check-line" />;
              return '';
            },
          });
        }
      }
    }
    if (editLinkUrl) {
      cols.unshift({
        id: 'edit',
        header: <EventLabel groupName="CMS.Voucher" name="PersonListEdit" />,
        hozAlign: 'center',
        cell: cell => {
          return (
            <button className="cms-button" style={{ fontSize: '0.8em' }} onClick={() => onEditClick(cell.row)}>
              <EventLabel groupName="CMS.Voucher" name="PersonListEditBtn" />
            </button>
          );
        },
      });
    }
    return cols;
  }, [personList, breakouts]);

  const onEditClick = row => {
    if (editLinkUrl) {
      window.open(editLinkUrl.replace(/\[BadgeNo\]/gi, row.original.badgeNo), '_blank');
    }
  };

  const updatePersonList = async badgeNo => {
    const { data } = await basedAxios.post(
      `./exhibitor/invites/list/${badgeNo}`,
      personTypes.map(pt => {
        return pt.value;
      })
    );
    if (data.success) {
      setPersonList(data.personList);
    }
  };
  const exportPersonList = async () => {
    try {
      const response = await basedAxios.get(
        `./exhibitor/invites/export/${orders[0].badgeNo}?ptypes=${personTypes.map(pt => pt.value).join(',')}&lang=${
          environment.lang
        }&useAltBreakoutName=${showAltName}`,
        {
          responseType: 'blob',
        }
      );

      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `InviteList_${orders[0].badgeNo}.xlsx`;
      link.click();
    } catch (error) {
      console.error(error);
    }
  };
  if (personList === null) {
    return (
      <div>
        <EventLabel groupName="CMS.Voucher" name="PersonListNothingToShowMessage" />
      </div>
    );
  }
  return (
    <div className="inner-wrap" style={{ minHeight: 50 }}>
      {showExportBtn ? (
        <button className="cms-button export-person-list-btn" style={{ fontSize: '0.8em' }} onClick={exportPersonList}>
          <EventLabel groupName="CMS.Voucher" name="PersonListExport" />
        </button>
      ) : null}
      {personTypes.length > 0 ? <h2>{personTypes.map(vt => vt.name).join(', ')}</h2> : null}
      {columnDefs?.length > 0 && personList?.length > 0 ? (
        <AdvancedTable cols={columnDefs} rows={personList} eventLabels={eventLabels} environment={environment} updateEventLabels={updateEventLabels} />
      ) : null}
    </div>
  );
};
